import { useEffect } from 'react';

export const useSyncSelectedDoctor = ({
    selectedInfo,
    selectedDoctorId,
    onSelectDoctorHandler,
}) => {
    useEffect(() => {
        if (selectedInfo?.doctors && selectedInfo.doctors !== selectedDoctorId) {
            onSelectDoctorHandler(selectedInfo.doctors);
        }
    }, [ selectedInfo?.doctors, selectedDoctorId, onSelectDoctorHandler ]);
};
